export default {"src":"/_next/static/media/icon-4.ae4fb404.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};